import { TypographySM } from "@/components/typography/SM";
import { Button } from "@/components/ui/button";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Eye, EyeOff } from "lucide-react";
import { useState } from "react";
import InboundSubscriptionTable from "./InboundSubscriptionTable";
import OutboundSubscriptionTable from "./OutboundSubscriptionTable";

interface Props {
  defaultTab?: string;
}

export function Subscriptions({ defaultTab }: Props) {
  const [filterInactive, setFilterInactive] = useState(false);

  return (
    <div>
      <Tabs defaultValue={defaultTab || "outbound"}>
        <div className="flex justify-end items-center gap-3 mb-6 mt-3 w-full">
          <TypographySM className="w-full text-brand-gray-800 dark:text-brand-gray-200">
            Subscriptions provide access to apps through a free or paid
            subscription format.
          </TypographySM>
          <Button
            variant="ghost"
            className="text-xs"
            data-testid="filter-inactive-subscriptions"
            onClick={() => setFilterInactive((prev) => !prev)}
          >
            {filterInactive ? (
              <EyeOff className="mr-2 h-4 w-4" />
            ) : (
              <Eye className="mr-2 h-4 w-4" />
            )}
            Filter inactive
          </Button>
          <TabsList>
            <TabsTrigger value="outbound" data-testid="outbound-tab-trigger">
              Outbound
            </TabsTrigger>
            <TabsTrigger value="inbound" data-testid="inbound-tab-trigger">
              Inbound
            </TabsTrigger>
          </TabsList>
        </div>
        <TabsContent value="outbound">
          <OutboundSubscriptionTable
            data-testid="outbound-table"
            filterInactive={filterInactive}
          />
        </TabsContent>
        <TabsContent value="inbound">
          <InboundSubscriptionTable
            data-testid="inbound-table"
            filterInactive={filterInactive}
          />
        </TabsContent>
      </Tabs>
    </div>
  );
}
